<template>
  <modal 
    name="custom-document-type-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'500px'"
    @before-open="beforeOpen">
    
    <div class="modal-header">
      <div class="modal-title">
        {{ title }}
      </div>

      <a href="#"
        @click.prevent="$modal.hide('custom-document-type-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>

    <div class="modal-body" v-if="documentType != null">
      <div class="">
        <label class="label-standard">Name</label>
      </div>

      <div class="form-line">
        <input type="text" class="input-standard" v-model="documentType.name" />
      </div>

      <div v-if="nameError !== null" class="text-red-600 mt-1 text-sm">{{ nameError }}</div>

      <div class="label-line">
        <label class="label-standard">Additional question you want the client answer when uploading</label>
      </div>

      <div class="mt-1 text-gray-700">
        This is to ask the client to describe the file they uploaded e.g. For a payslip, which employer and month is this?
      </div>

      <div class="form-line">
        <input type="text" class="input-standard" v-model="documentType.question" />
      </div>

      <div class="label-line">
        <label class="label-standard">Tooltip text to further describe this document</label>
      </div>

      <div class="mt-1 text-gray-700">
        This could be used to give further instructions to the client about what you need.
      </div>

      <div class="form-line">
        <input type="text" class="input-standard" v-model="documentType.tooltip" />
      </div>
    </div>

    <div class="modal-footer">
      <SubmitButton2 label="Save" :onClick="submit" :loading="loading" />
    </div>
  </modal>
</template>

<script>
  import InputText      from '@/shared/components/form/InputText'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  import { EventBus }   from '@/shared/event-bus'
  
  export default {

    components : {
      InputText,
      SubmitButton2
    },

    data() {
      return {
        title           : null,
        loading         : false,
        documentType    : null,
        nameError       : null,
        categoryIndex   : null,
        subcategoryIndex: null
      }
    },

    methods : {
      beforeOpen(event) {
        this.categoryIndex    = null
        this.subcategoryIndex = null

        if(event.params.categoryIndex != null) {
          this.categoryIndex = event.params.categoryIndex
        }

        if(event.params.subcategoryIndex != null) {
          this.subcategoryIndex = event.params.subcategoryIndex
        }

        if(event.params.documentType != null) {
          this.documentType = event.params.documentType

          if(this.documentType.id != null) {
            this.title = "Update custom document type"
          } else {
            this.title = "Add a new custom document type"
          }
        }
      },

      updateValue(params) {
        this.documentType[params.key] = params.value
      },

      submit() {
        let valid = true
        this.nameError = null
        
        if(this.documentType.name == null || this.documentType.name.length == 0) {
          this.nameError = "Please provide a valid name for this documentType"
          valid = false
        }

        if(valid) {
          this.loading = true
          this.apiPost({
            clientId    : this.$route.params.clientId,
            documentType: this.documentType
          }, 'document/custom-document-type', (documentType) => {
            this.loading = false
            this.$modal.hide('custom-document-type-modal')
            EventBus.$emit('get-document-types')
            EventBus.$emit('notification-event', {
              'type'   : 'success',
              'message': "Template saved successfully"
            })
          })
        }
      },
    }
  }
</script>